import strings from "../../../localization";
import {useDispatch} from "react-redux";
import {useNavigate, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import PageState from "../../../Constants/Base/PageState";
import TablePageContext, {
    FilterDefaults,
    TableDataDefaults,
    TablePageOptionDefaults
} from "../../../Context/TablePageContext";
import ReferenceType from "../../../Constants/DocumentManagement/ReferenceType";
import AppPermissions from "../../../Constants/Permissions/Permissions";
import {changePageSizeState} from "../../../Slices/PageSlice";
import PageSizeState from "../../../Constants/Base/PageSizeState";
import {changeBreadcrumbs} from "../../../Slices/BreadcrumbsSlice";
import Modules from "../../../Constants/Base/Modules";
import TablePage from "../../../Components/DataGrid/TablePage";
import EditContractPartStatus from "./EditContractPartStatus";
import AddContractPartStatus from "./AddContractPartStatus";
import {deleteContractPartStatus, getContractPartStatuses} from "../../../Services/Finance/ContractPartStatusService";
import Tag from "../../../Components/Forms/Pages/Document/Tag/Tag";


const tableDescription = [
    {field: 'name', headerName: strings.pages.finance.contractStatus.contractStatusList.name, width: 200},
];

const filters = [];

const ContractPartStatusList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [updatedFilter, setUpdatedFilter] = useState(!Boolean(searchParams.toString()));
    const [columns, setColumns] = useState([]);
    const [pageState, setPageState] = useState(PageState.View);
    const [filter, setFilter] = useState(FilterDefaults);
    const [tableData, setTableData] = useState(TableDataDefaults);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const [selectedItems, setSelectedItems] = useState(null);
    const [tablePageOptions, setTablePageOptions] = useState(TablePageOptionDefaults);
    const referenceType = ReferenceType.CONTRACT_PART_STATUS;
    const permissionGroup = AppPermissions.CONTRACT_PART_STATUS.GROUP;

    const value = {
        tablePageOptions, setTablePageOptions,
        selectionModel, setSelectionModel,
        selectedItems, setSelectedItems,
        filter, setFilter, pageState, setPageState, showDeleteDialog, setShowDeleteDialog,
        navigate, updatedFilter, setUpdatedFilter
    }

    useEffect(() => {

        setColumns([...tableDescription]);
        dispatch(changePageSizeState(PageSizeState.SHORT));
        dispatch(changeBreadcrumbs({
            title: strings.pages.finance.settings.contractPartStatus,
            hierarchy:[
                {label: strings.navigation.managmentTag},
                {label: Modules.FINANCE},
                {label: strings.pages.finance.settings.settings},
                {label: strings.pages.finance.settings.contractPartStatus},
            ],
        }));

        return () => {
            setTableData({})
        }
    }, [])

    useEffect(() => {
        if(!updatedFilter){
            return;
        }

        fetch();
    }, [filter, updatedFilter])

    const onCancel = () => {
        setPageState(PageState.View);
    }

    const onFinish = () => {
        fetch();
        setPageState(PageState.View);
    }

    const fetch = () => {
        setTableData({
            ...tableData,
            loading: true
        });

        getContractPartStatuses({
            ...filter
        }).then(response => {
            if (!response || !response.ok) {
                return;
            }

            setTableData({
                loading: false,
                data: response.data.result,
                total: response.data.total
            });
        })
    }

    return <TablePageContext.Provider value={value}>

        <TablePage onFinish={() => onFinish()} tableDescription={columns} deleteItem={deleteContractPartStatus}
                   tableData={tableData}
                   filter={filter} filters={filters}
                   permissionGroup={permissionGroup}
                   referenceType={referenceType}
                   onCancel={() => onCancel()}
                   tagPage={<Tag referenceType={ referenceType } data={ selectedItems } /> }
                   editPage={<EditContractPartStatus data={selectedItems} onFinish={() => onFinish()}
                                                 onCancel={() => onCancel()}/>}
                   addPage={<AddContractPartStatus onCancel={() => onCancel()} onFinish={() => onFinish()}/>
                   }
                   hideBreadcrumbs
                   addButtonText={strings.components.tablePage.addButton.contractPartStatus}
        />
    </TablePageContext.Provider>;
}
export default ContractPartStatusList;